import React from 'react'
import { Text } from '../Text/component'
import { IProps } from './index'
import { BrandOptions, useBrand } from '../../providers/brandProvider'
import { PriceForPeriod as PriceForPeriodDefault } from './element'

export const PriceForPeriod = (props: IProps) => {
  const theme = useBrand()
  if (theme === BrandOptions.default) {
    return <PriceForPeriodDefault {...props} />
  }
  return <PriceForPeriodLegacy {...props} />
}

const PriceForPeriodLegacy = (props: IProps) => {
  const { price, simple, small, subText } = props
  const introText = props.introText || 'from'
  const periodText = props.periodText || 'mo'
  return (
    <div className="monthly-price">
      <div className="monthly-price-bottom-row">
        {!simple && <Text size="body">{introText}&nbsp; </Text>}
        <Text size={small ? 'body+' : 'lg+'}>${price}</Text>
        <Text size="body">/{periodText}</Text>
      </div>
      {subText && (
        <div className="monthly-price-subtext">
          <Text size="caption">{subText}</Text>
        </div>
      )}
      <style jsx>
        {`
          .monthly-price {
            display: grid;
            grid-template-rows: auto;
            word-break: break-word;
          }

          .monthly-price-top-row {
            grid-row: 1;
          }

          .monthly-price-bottom-row {
            grid-row: 2;
          }
        `}
      </style>
    </div>
  )
}
